const eventCategories = {
    FUNNEL: "Funnel",
    START_QUOTE: "StartQuote",
};

export default eventCategories;
